<template>
    <div class="c-tr" :class="{ 'm-checkList__row--active': isTarget }">
        <accordion
            class="w-100"
            header-class="merge-bags-row"
            :is-active="isActive"
        >
            <template #header>
                <div class="c-td">
                    <span v-text="'Docelowy'" class="typo-label" />
                    <ui-checkbox-input
                        type="radio"
                        name="target-bag"
                        :value="isTarget"
                        @change="setTargetId($event)"
                    />
                </div>
                <div class="c-td">
                    <div v-text="'Frakcja'" class="typo-label" />
                    <fraction-label :fraction="fraction" />
                </div>
                <div class="c-td">
                    <div v-text="'Status'" class="typo-label" />
                    <span v-text="'Otwarty'" class="is-success status w-100" />
                </div>
                <div class="c-td">
                    <div v-text="'Wartość worka'" class="typo-label" />
                    <strong v-text="total" />
                    ({{ quantity }} szt.)
                </div>
            </template>
            <template #expand-button>
                <div class="c-td d-flex justify-content-between">
                    <the-btn
                        text="Pokaż zawartość"
                        class="btn-custom-gray btn-sm"
                        :icon="isActive ? 'ArrowUp' : 'ArrowDown'"
                        @click="setExpandedId"
                    />
                    <the-btn
                        v-text="'Usuń'"
                        class="btn-sm btn-danger"
                        @click="deletePackage"
                    />
                </div>
            </template>
            <template #body>
                <bag-eans class="mb-3" :bag="bag" />
            </template>
        </accordion>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import bagsMixin from '@/components/drs/stores/bags/bags.mixin'

export default {
    mixins: [bagsMixin],

    props: {
        bag: {
            type: Object,
            required: true
        },
        expandedId: {
            type: Number,
            default: null
        },
        targetId: {
            type: Number,
            default: null
        }
    },

    computed: {
        isActive() {
            return this.expandedId === this.bag.package_id
        },

        isTarget() {
            return this.targetId === this.bag.package_id
        }
    },

    methods: {
        ...mapActions('drsBags', ['togglePackageInMode']),

        setExpandedId() {
            this.$emit('setExpandedId', this.isActive ? null : this.bag.package_id)
        },

        setTargetId(value) {
            this.$emit('setTargetId', value ? this.bag.package_id : null)
        },

        deletePackage() {
            if (this.isTarget) {
                this.$emit('setTargetId', null)
            }

            this.togglePackageInMode(this.bag.package_id)
        }
    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';
@import '~bootstrap/scss/mixins';
.c-table--merge-bags {
    .a-accordion, .a-accordion:hover {
        border: none;
        margin-bottom: 0 !important;
        background: inherit;

        .merge-bags-row {
            font-size: var(--font-size-sm);
            padding: 0;
            position: sticky;
            top: -18px;
            z-index: 1;

            @include media-breakpoint-down(sm) {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                padding: 1rem 0;

                .c-td {
                    max-width: 100%;
                    width: 100%;
                    height: 100%;
                    padding: 0;

                    &:nth-child(5) {
                        min-width: 100%;
                        grid-column: 1 / -1;
                    }

                    .typo-label {
                        display: flex;
                    }
                }
            }
        }

        .card-body {
            padding: 0 !important;
        }
    }

    .merge-bags-row {
        background-color: var(--color-white);
    }

    .m-checkList__row--active .merge-bags-row {
        background-color: var(--active-promo-bg);
    }
}
</style>